import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { 
  UserProfileWithRolesDto, 
  UserCompanyRoleSetUpdateDto, 
  UserCompanyRoleSetViewDto,
  UserProfileCreateDto,
  UserProfileCreationResultDto
} from '@/types/userRoles'

// User roles API functions
export const userRolesApi = {
  /**
   * Get all user role assignments for a specific company
   */
  getUserRolesByCompany: (clientCompanyId: string): Promise<ApiResponse<UserProfileWithRolesDto[]>> =>
    apiClient.get(`/api/UserCompanyRoles/Company/${clientCompanyId}`),

  /**
   * Update user company role set. The route carries the tenant
   * (userProfileId + clientCompanyId); the server forces Id from the route (ORB-306).
   */
  updateUserCompanyRoleSet: (
    userProfileId: string,
    clientCompanyId: string,
    updateDto: UserCompanyRoleSetUpdateDto
  ): Promise<ApiResponse<UserCompanyRoleSetViewDto>> =>
    apiClient.put(`/api/UserCompanyRoles/${userProfileId}/${clientCompanyId}`, updateDto),

  /**
   * Create a new user with initial role assignments
   */
  createUser: (
    createDto: UserProfileCreateDto
  ): Promise<ApiResponse<UserProfileCreationResultDto>> =>
    apiClient.post('/api/Users/CreateUser', createDto),

  /**
   * Soft delete a user from a client company
   */
  deleteUser: (
    userProfileId: string,
    clientCompanyId: string
  ): Promise<ApiResponse<void>> =>
    apiClient.delete(`/api/Users/${userProfileId}/ClientCompany/${clientCompanyId}`),
}
